import { Vehicle } from "../../features/core/models";

export const vehiclesWithSpecificAlertTypeActive = (vehicles, alertType: number) => {
    const filteredVehicles = vehicles.filter((vehicle) => {
        return vehicle.vehicle_alerts.some(
            (alert) => alert.active && alert.type == alertType
        );
    });
    return filteredVehicles.length;
}
